export default __webpack_public_path__ + "static/media/lions_lions_tr.01efeb7e.png";